<template>
  <div class="wrap">
    <p>
      <img class="mainImg" src="@/assets/img/gijang/2403_main.png" /><br />
      <img class="btn" src="@/assets/img/gijang/2305_main_btn.png" usemap="#Map" />
      <map name="Map">
        <area shape="rect" coords="10,11,272,67" href="/notice" target="_blank" />
        <area shape="rect" coords="283,10,458,69" href="/schedule" target="_blank" />
        <area shape="rect" coords="465,8,644,69" href="/gjrepresent" target="_blank" />
      </map>
    </p>
  </div>
</template>

<script>
import ImageMap from "image-map";

export default {
  methods: {
    newPage(path) {
      window.open(path, "_blank");
    },
  },
  mounted() {
    // Mounted
    // ImageMap("img[usemap]");
    // window.open("/popup","_popup","toolbar=no,scrollbars=no,resizable=no,status=no,menubar=no,width=600, height=600, top=0,left=0");
  },
};
</script>

<style lang="scss" scoped></style>
<style lang="scss">
.wrap {
  text-align: center;
}
.menu {
  display: none;
}
@media only screen and (max-width: 900px) {
  .wrap {
    width: 100%;
    margin: 0 auto;
  }
  .mainImg {
    width: 100%;
  }
  .btn {
    width: 100%;
  }
}
#nav {
  display: none;
}
</style>
